<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M29.334 4.636c0-.1 0-.1 0 0v-.302h-5.687c-.392 0-.49.201-.588.704-.196.603-2.255 8.448-3.921 14.684-.098.201-.098.402-.197.704-.294 1.106-.588 2.213-.882 3.118a120.903 120.903 0 00-1.078 4.023h4.215c1.275 0 2.157-1.006 2.55-2.314.098-.402 1.176-4.425 2.352-8.75v-.1c1.275-4.828 2.745-10.158 3.04-11.264 0-.101.098-.202.098-.302.098 0 .098 0 .098-.201 0 .1 0 .1 0 0zm-14.314 0c0-.1 0-.1 0 0v-.302H9.334c-.393 0-.49.201-.589.704-.196.603-2.254 8.448-3.921 14.684a7861.88 7861.88 0 00-2.157 7.945h4.216c1.274 0 2.157-1.005 2.549-2.313.098-.402 1.176-4.425 2.353-8.75v-.1c1.274-4.828 2.745-10.159 3.039-11.265 0-.1.098-.201.098-.302.098-.1.098-.1.098-.301 0 .1 0 .1 0 0z"/></svg>
</template>

<script>
export default {
  name: 'brandLocawebFilled'
}
</script>
